import React from 'react';
import PropTypes from 'prop-types';

import { Label, Input, CustomRadio } from './style';
import Arial from '../../typography/arial';

const RadioButtonSurvey = ({
  label,
  name,
  value,
  onChange
}) => {
  const handleOnChange = (e) => {
    const { currentTarget } = e;
    if (onChange) onChange(currentTarget.value);
  };
  return (
    <Label>
      <Input type="radio" name={name} value={value} onChange={handleOnChange} />
      <Arial>{label}</Arial>
      <CustomRadio />
    </Label>
  );
};


RadioButtonSurvey.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default RadioButtonSurvey;
